import cn from 'classnames';

interface TooltipActionsWrapper
  extends Pick<JSX.IntrinsicElements['div'], 'children' | 'className'> {
  actions?: React.ReactNode;
}

export function TooltipActionsWrapper({
  actions,
  children,
  className,
}: TooltipActionsWrapper) {
  return (
    // TODO: support custom tag, for now we only need list item
    <li className={cn('group relative', className)}>
      {children}
      {actions && (
        <div className="absolute right-3 top-3 z-10 flex items-center gap-x-1 rounded-[4px] border border-gray-200 bg-white p-1 opacity-0 shadow-elevation-100 transition-all duration-300 focus-within:opacity-100 group-hover:opacity-100">
          {actions}
        </div>
      )}
    </li>
  );
}
